import { Observable } from "rxjs";
import { BRAND_GENERIC_UPDATE_COMPLETE, BRAND_ADMIN_UPDATE_EMAIL_IMAGE_START } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";
// import { updateEntities } from "redux-query";

export const updateEmailHeaderImageFieldEpic = (action$, store) => {
    // look to make a new action and type
    return action$
        .ofType(BRAND_ADMIN_UPDATE_EMAIL_IMAGE_START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((payload) => {
            return ajax({
                method: "POST",
                body: {
                    settings: {
                        [payload.key]: "",
                    },
                },
                url: `${siteConfig.api}/brand/info/update-base`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({ message: formatMessage("Error Clearing Email Header Image") })
                            ),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_GENERIC_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: { key: `settings.${payload.key}`, body: payload.body },
                                type: BRAND_GENERIC_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Image removed") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error Clearing Email Header Image ERROR CASE");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to clear the Email Header Image");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_GENERIC_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
